import * as Generated from './generated/AnalyticsBeacons'

// Alias the really long namespaces then re-export them in more consumable forms
// These are pretty common structs.
import FlippWebBase = Generated.com.flipp.beacon.flipp.web.entity.FlippWebBase
import BrowseContext = Generated.com.flipp.beacon.flipp.web.entity.browse.BrowseContext
import FlippWebBaseExtended = Generated.com.flipp.beacon.flipp.web.entity.FlippWebBaseExtended
import Environment = Generated.com.flipp.beacon.flipp.web.enumeration.Environment
import ClientParameters = Generated.com.flipp.beacon.flipp.web.entity.ClientParameters
import AdAdaptedAdContext = Generated.com.flipp.beacon.flipp.web.entity.adadapted.AdAdaptedAdContext
import LocationSource = Generated.com.flipp.beacon.flipp.web.enumeration.LocationSource

// Beacons
import BrowseBeacon = Generated.com.flipp.beacon.flipp.web.event.browse

enum Schemas {
    BrowseAdAdaptedImpressionAdSchemaId = Generated.BrowseAdAdaptedImpressionAdSchemaId,
    BrowseAdAdaptedViewableImpressionAdSchemaId = Generated.BrowseAdAdaptedViewableImpressionAdSchemaId,
    BrowseAdAdaptedOpenAddToShoppingListAdSchemaId = Generated.BrowseAdAdaptedOpenAddToShoppingListAdSchemaId,
    BrowseAdAdaptedOpenAddToCartAdSchemaId = Generated.BrowseAdAdaptedOpenAddToCartAdSchemaId,
}

export {
    FlippWebBase,
    FlippWebBaseExtended,
    BrowseContext,
    AdAdaptedAdContext,
    BrowseBeacon,
    Schemas,
    ClientParameters,
    LocationSource,
    Environment,
}
